import { Spinner } from "~/components/ui/spinner";

interface LoadingPanelProps {
  message?: string;
}

export function LoadingPanel({ message = "Loading..." }: LoadingPanelProps) {
  return (
    <div className="bg-background flex flex-col items-center justify-center gap-3 rounded-xl border p-8 text-center">
      <Spinner className="size-6" />
      <p className="body-sm text-muted-foreground">{message}</p>
    </div>
  );
}
